var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.7612 16.6052L13.0413 11.8848C15.3358 9.01329 15.1558 4.80014 12.4973 2.14135C9.6424 -0.713782 4.99605 -0.713782 2.14116 2.14135C-0.713722 4.99648 -0.713722 9.64322 2.14116 12.4984C3.56861 13.9259 5.44187 14.6377 7.31922 14.6377C8.9389 14.6377 10.5545 14.1018 11.8838 13.0424L16.6037 17.7628C16.7633 17.9223 16.9718 18 17.1804 18C17.389 18 17.5976 17.9182 17.7571 17.7587C18.0803 17.4437 18.0803 16.9242 17.7612 16.6052ZM3.29866 11.3408C1.08183 9.12374 1.08183 5.51596 3.29866 3.29894C4.40708 2.19043 5.86315 1.63413 7.31922 1.63413C8.7753 1.63413 10.2314 2.19043 11.3398 3.29894C13.5566 5.51596 13.5566 9.12374 11.3398 11.3408C9.12296 13.5578 5.51549 13.5578 3.29866 11.3408Z","fill":"#34495E"}));
}

SearchIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
